var _path, _path2, _path3, _path4, _rect, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _g2, _path14, _path15, _g3, _path16, _path17, _g4, _path18, _path19, _g5, _path20, _path21, _g6, _path22, _path23, _g7, _path24, _path25, _g8, _path26, _path27, _g9, _path28, _path29, _g10, _path30, _path31, _g11, _path32, _path33, _g12, _path34, _path35, _g13, _path36, _path37, _g14, _path38, _path39, _g15, _path40, _path41, _g16, _path42, _path43, _g17, _path44, _path45, _g18, _path46, _path47, _g19, _path48, _path49, _g20, _path50, _path51, _g21, _path52, _path53, _g22, _path54, _path55, _g23, _path56, _path57, _g24, _path58, _path59, _g25, _path60, _path61, _g26, _path62, _path63, _g27, _path64, _path65, _g28, _path66, _path67, _g29, _path68, _path69, _g30, _path70, _path71, _g31, _path72, _path73, _g32, _path74, _path75, _g33, _path76, _path77, _g34, _path78, _path79, _g35, _path80, _path81, _g36, _path82, _path83, _g37, _path84, _path85, _g38, _path86, _path87, _g39, _path88, _path89, _g40, _path90, _path91, _g41, _path92, _path93, _g42, _path94, _path95, _g43, _path96, _path97, _g44, _path98, _path99, _g45, _path100, _path101, _g46, _path102, _path103, _g47, _path104, _path105, _g48, _path106, _path107, _g49, _path108, _path109, _g50, _path110, _path111, _g51, _path112, _path113, _g52, _path114, _path115, _g53, _path116, _path117, _g54, _path118, _path119, _g55, _path120, _path121, _g56, _path122, _path123, _g57, _path124, _path125, _g58, _path126, _path127, _g59, _path128, _path129, _g60, _path130, _path131, _g61, _path132, _path133, _g62, _path134, _path135, _g63, _path136, _path137, _g64, _path138, _path139, _g65, _path140, _path141, _g66, _path142, _path143, _g67, _path144, _path145, _g68, _path146, _path147, _g69, _path148, _path149, _g70, _path150, _path151, _g71, _path152, _path153, _g72, _path154, _path155, _g73, _path156, _path157, _g74, _path158, _path159, _g75, _path160, _path161, _g76, _path162, _path163, _g77, _path164, _path165, _g78, _path166, _path167, _g79, _path168, _path169, _g80, _path170, _path171, _g81, _path172, _path173, _g82, _path174, _path175, _g83, _path176, _path177, _g84, _path178, _path179, _g85, _path180, _path181, _g86, _path182, _path183, _g87, _path184, _path185, _g88, _path186, _path187, _g89, _path188, _path189, _g90, _path190, _path191, _g91, _path192, _path193, _g92, _path194, _path195, _g93, _path196, _path197, _g94, _path198, _path199, _g95, _path200, _path201, _g96, _path202, _path203, _g97, _path204, _path205, _g98, _path206, _path207, _g99, _path208, _path209, _g100, _path210, _path211, _g101, _path212, _path213, _g102, _path214, _path215, _g103, _path216, _path217, _g104, _path218, _path219, _g105, _path220, _path221, _g106, _path222, _path223, _g107, _path224, _path225, _g108, _path226, _path227, _g109, _path228, _path229, _g110, _path230, _path231, _g111, _path232, _path233, _g112, _path234, _path235, _g113, _path236, _path237, _g114, _path238, _path239, _g115, _path240, _path241, _g116, _path242, _path243, _g117, _path244, _path245, _g118, _path246, _path247, _g119, _path248, _path249, _g120, _path250, _path251, _g121, _path252, _path253, _g122, _path254, _path255, _g123, _path256, _path257, _g124, _path258, _path259, _g125, _path260, _path261, _g126, _path262, _path263, _g127, _path264, _path265, _g128, _path266, _path267, _g129, _path268, _path269, _g130, _path270, _path271, _g131, _path272, _path273, _g132, _path274, _path275, _g133, _path276, _path277, _g134, _path278, _path279, _g135, _path280, _path281, _g136, _path282, _path283, _g137, _path284, _path285, _g138, _path286, _path287, _g139, _path288, _path289, _g140, _path290, _path291, _g141, _path292, _path293, _g142, _path294, _path295, _g143, _path296, _path297, _g144, _path298, _path299, _g145, _path300, _path301, _g146, _path302, _path303, _g147, _path304, _path305, _g148, _path306, _path307, _g149, _path308, _path309, _g150, _path310, _path311, _g151, _path312, _path313, _g152, _path314, _path315, _g153, _path316, _path317, _g154, _path318, _path319, _g155, _path320, _rect3, _path321;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoIconEvent = function SvgLogoIconEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 47,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M30.675 44.382v2.051c0 .484-.144.64-.628.536-.692-.157-1.424-.222-2.09-.457-.942-.327-1.91-.588-2.811-1.02-.588-.287-1.19-.561-1.765-.862a16.79 16.79 0 0 1-2.104-1.333c-.941-.706-1.856-1.437-2.667-2.3-1.542-1.66-2.836-3.49-3.83-5.54a26.592 26.592 0 0 1-.784-1.791 10.903 10.903 0 0 1-.68-2.444c-.091-.549-.222-1.098-.261-1.66-.013-.222.065-.26.261-.26 1.543.012 3.072.012 4.614 0 .183 0 .236.052.275.221.144.654.288 1.307.497 1.934.81 2.444 2.13 4.561 3.986 6.338 1.543 1.477 3.32 2.601 5.32 3.32.732.261 1.49.51 2.275.627.34.04.418.183.405.51-.026.705-.013 1.411-.013 2.13ZM50.426 29.301c.732 0 1.45.013 2.182 0 .314-.013.445.013.367.418a25.826 25.826 0 0 1-1.23 4.535c-.47 1.28-1.123 2.47-1.855 3.607-2.013 3.123-4.72 5.475-8.026 7.148-1.49.745-3.046 1.32-4.666 1.673-.497.104-1.007.157-1.517.248-.222.04-.3-.013-.3-.261.013-1.53.013-3.045 0-4.574 0-.222.065-.3.313-.353.85-.17 1.686-.418 2.497-.745.797-.314 1.569-.653 2.3-1.124.55-.353 1.138-.68 1.66-1.084.68-.523 1.334-1.085 1.909-1.739.863-.966 1.634-2.012 2.248-3.149.3-.562.628-1.11.706-1.79.026-.196.274-.484.353-.758.17-.601.353-1.19.457-1.804.04-.248.118-.26.314-.26.745.012 1.516.012 2.288.012ZM50.36 24.61c-.745 0-1.477-.026-2.222.013-.327.013-.379-.183-.405-.353-.34-2.078-1.163-3.947-2.327-5.698a13.66 13.66 0 0 0-2.366-2.692c-1.176-1.032-2.444-1.934-3.908-2.56a19.051 19.051 0 0 0-3.464-1.099c-.183-.039-.3-.13-.3-.34 0-1.555.013-3.11 0-4.652 0-.209.091-.248.261-.222 1.987.327 3.921.863 5.764 1.712 2.562 1.163 4.758 2.823 6.614 4.9 2.053 2.314 3.556 4.94 4.366 7.946.222.823.392 1.647.575 2.47.118.536.066.575-.483.575H50.36ZM33.015 27.197l-.105.105v-.157c-.157-.601-.562-1.072-.862-1.607-.68-1.229-1.412-2.431-2.118-3.633-.04-.066-.04-.144-.092-.183-.588-.588-.313-1.085.053-1.686.98-1.607 1.895-3.267 2.81-4.9.052-.105.13-.183.196-.275.078-.104.118-.209.235.026.38.732.798 1.438 1.23 2.143.378.64.705 1.333 1.097 1.96.863 1.386 1.53 2.889 2.484 4.209.013.026.039.052.052.065.235.653.653 1.215.993 1.803 1.255 2.143 2.484 4.287 3.726 6.443.34.588.68 1.176 1.006 1.75-.078.145-.196.092-.288.092-2.17 0-4.352 0-6.522.013-.288 0-.444-.104-.575-.34-.654-1.162-1.281-2.338-2-3.462-.484-.745-.863-1.542-1.281-2.313.052-.053.04-.092-.04-.053ZM30.688 7.674c0 1.306-.026 2.613 0 3.92 0 .418-.091.562-.549.64a14.285 14.285 0 0 0-6.065 2.692c-2.575 1.974-4.392 4.496-5.412 7.58-.17.535-.352 1.071-.405 1.646-.026.314-.143.47-.523.47-1.398-.038-2.784-.012-4.182-.012-.51 0-.628-.131-.51-.614.235-1.046.431-2.091.771-3.11a21.016 21.016 0 0 1 1.987-4.3c.392-.653.85-1.28 1.268-1.921.052-.04.104-.092.157-.13.052-.08.117-.145.17-.223.902-1.098 1.986-1.973 3.15-2.744 1.738-1.163 3.568-2.143 5.555-2.836 1.503-.523 3.02-.915 4.588-1.058Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M32.923 27.145v.157c-.706 1.424-1.607 2.744-2.366 4.13-.3.561-.653 1.11-.954 1.672-.104.196-.235.275-.47.275-2.249-.014-4.497-.014-6.745-.014 0-.052-.013-.104-.013-.156.183-.68.666-1.19.993-1.79.785-1.412 1.621-2.81 2.431-4.209.027-.026.053-.052.079-.065h7.045Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C51818",
    d: "M9.805 15.279c-1.31 1.162-3.06.861-3.77.565-.26.394-.752 1.205-.642 1.307.138.127 2.236.572 4.356 0 2.12-.572 3.598-2.15 3.734-2.281.164-.158.623-.52.923-.666l13.812-7.095c.997.01 2.557-.454.826-2.383-2.165-2.412-4.24-3.715-7.119-4.198-2.878-.482-5.632 1.035-6.586 1.683-.953.648-2.188 2.127-2.787 3.582-.48 1.163-.863 4.416-.994 5.897-.04.712-.444 2.427-1.753 3.589Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE0BC",
    d: "M26.113 8.732c1.49-.523 3.006-.915 4.575-1.058 1.007-.327 1.059-.497.497-1.438-.026-.052-.04-.104-.079-.157-.523-.718-1.02-1.503-2.078-1.463-.34 0-.654.104-.967.222-1.438.536-2.863 1.084-4.248 1.764a42.778 42.778 0 0 0-5.477 3.24c-1.046.72-2.026 1.517-2.994 2.327-.575.483-1.163.967-1.176 1.83-.005.212.016.764.144 1.267.065.431.379.667.732.758.366.105.706-.065.98-.392.3-.353.562-.81 1.059-.967.052-.04.105-.091.157-.13-.013-.131.026-.223.17-.223.902-1.085 1.986-1.96 3.15-2.744 1.738-1.163 3.568-2.143 5.555-2.836Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.882,
    height: 5.881,
    x: 0.507,
    y: 12.131,
    fill: "#FEE0BC",
    rx: 2.94
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C51818",
    d: "M9.805 15.279c-1.31 1.162-3.06.861-3.77.565-.26.394-.752 1.205-.642 1.307.138.127 2.236.572 4.356 0 2.12-.572 3.598-2.15 3.734-2.281.164-.158.623-.52.923-.666l13.812-7.095c.997.01 2.557-.454.826-2.383-2.165-2.412-4.24-3.715-7.119-4.198-2.878-.482-5.632 1.035-6.586 1.683-.953.648-2.188 2.127-2.787 3.582-.48 1.163-.863 4.416-.994 5.897-.04.712-.444 2.427-1.753 3.589Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE0BC",
    d: "M26.113 8.732c1.49-.523 3.006-.915 4.575-1.058 1.007-.327 1.059-.497.497-1.438-.026-.052-.04-.104-.079-.157-.523-.718-1.02-1.503-2.078-1.463-.34 0-.654.104-.967.222-1.438.536-2.863 1.084-4.248 1.764a42.778 42.778 0 0 0-5.477 3.24c-1.046.72-2.026 1.517-2.994 2.327-.575.483-1.163.967-1.176 1.83-.005.212.016.764.144 1.267.065.431.379.667.732.758.366.105.706-.065.98-.392.3-.353.562-.81 1.059-.967.052-.04.105-.091.157-.13-.013-.131.026-.223.17-.223.902-1.085 1.986-1.96 3.15-2.744 1.738-1.163 3.568-2.143 5.555-2.836Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.882,
    height: 5.881,
    x: 0.507,
    y: 12.131,
    fill: "#FEE0BC",
    rx: 2.94
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.947 17.777c0-.525-.172-.922-.486-1.178-.315-.255-.744-.383-1.287-.383-.4 0-.786.085-1.144.241a2.922 2.922 0 0 0-.9.596l-.744-.893a3.82 3.82 0 0 1 1.301-.78 4.821 4.821 0 0 1 1.644-.284c.515 0 .958.07 1.33.213.386.141.686.34.93.595.242.241.428.54.542.88.115.34.172.709.172 1.092v3.092c0 .241.014.497.028.752.015.255.043.482.086.652h-1.286a4.108 4.108 0 0 1-.115-1.007h-.043c-.257.383-.6.667-.986.88-.386.212-.872.312-1.416.312-.285 0-.571-.029-.872-.114a2.316 2.316 0 0 1-.829-.369 2.181 2.181 0 0 1-.629-.666c-.172-.284-.243-.624-.243-1.036 0-.539.143-.964.443-1.29a2.92 2.92 0 0 1 1.144-.724c.472-.17 1.015-.27 1.601-.312.6-.043 1.187-.07 1.787-.07l-.028-.2Zm-.343 1.22c-.358 0-.715.014-1.087.042-.386.028-.73.1-1.015.17a2.12 2.12 0 0 0-.758.397c-.2.17-.3.426-.3.724 0 .213.043.383.129.525.085.141.2.255.343.34.143.1.3.156.457.184.158.029.343.043.53.043.671 0 1.172-.199 1.529-.596.357-.383.529-.893.529-1.49v-.368h-.357v.028Zm6.39-6.27c0 .255-.1.468-.271.652a.944.944 0 0 1-.672.256.91.91 0 0 1-.658-.256.823.823 0 0 1-.272-.638c0-.255.1-.468.272-.652.172-.185.4-.256.658-.256.257 0 .486.085.672.256a.852.852 0 0 1 .271.638Zm-.228 9.645H68.35V15.28h1.416v7.092Zm4.703 0h-1.501V11.791h3.417c.515 0 1 .042 1.458.156.458.1.872.27 1.215.51.344.227.615.525.815.908.2.383.3.823.3 1.362 0 .78-.243 1.404-.729 1.886-.486.483-1.1.78-1.858.908l2.974 4.866h-1.802l-2.716-4.71H74.44v4.71l.028-.015Zm0-5.957h1.716c.357 0 .672-.028.986-.1.3-.056.572-.155.8-.297.23-.128.401-.312.53-.525.128-.213.2-.482.2-.794 0-.313-.072-.596-.2-.795a1.693 1.693 0 0 0-.53-.525 2.09 2.09 0 0 0-.757-.27c-.3-.056-.6-.084-.915-.084h-1.83v3.39Zm10.008-3.688c0 .255-.1.468-.272.652a.944.944 0 0 1-.672.256.933.933 0 0 1-.657-.256.823.823 0 0 1-.272-.638c0-.255.1-.468.272-.652.171-.185.4-.256.657-.256.258 0 .472.085.672.256a.852.852 0 0 1 .272.638Zm-.229 9.645h-1.415V15.28h1.415v7.092Zm3.703 1.206c.315.355.7.624 1.158.837.458.213.944.312 1.43.312.472 0 .872-.071 1.186-.199.315-.127.587-.312.772-.553.2-.241.33-.51.43-.823.085-.312.128-.666.128-1.035v-.908h-.029c-.257.397-.614.71-1.072.908a3.392 3.392 0 0 1-1.444.312c-.543 0-1.03-.1-1.487-.284a3.266 3.266 0 0 1-1.143-.78 3.581 3.581 0 0 1-.73-1.149 3.961 3.961 0 0 1-.257-1.418c0-.51.086-.993.257-1.433a3.56 3.56 0 0 1 .73-1.177 3.594 3.594 0 0 1 1.129-.794 3.593 3.593 0 0 1 1.473-.298c.514 0 1 .099 1.472.326.458.227.83.553 1.101 1.007h.029v-1.135h1.372v6.724c0 .524-.071 1.007-.2 1.49a3.176 3.176 0 0 1-.672 1.262c-.315.368-.73.666-1.23.865-.5.227-1.129.326-1.858.326a5.512 5.512 0 0 1-1.873-.34 4.807 4.807 0 0 1-1.616-.95l.944-1.093Zm.415-4.837c0 .326.043.653.157.936.1.298.257.568.457.795.2.227.458.411.744.553.3.142.629.213 1 .213.372 0 .701-.057 1.001-.199.3-.128.558-.312.772-.525.215-.227.386-.482.487-.794.114-.312.171-.638.171-.979 0-.34-.057-.666-.171-.95a2.42 2.42 0 0 0-.5-.795 2.29 2.29 0 0 0-.773-.539 2.499 2.499 0 0 0-.986-.198c-.372 0-.7.07-1.001.198-.3.128-.543.313-.744.54-.2.226-.371.482-.457.794a3.01 3.01 0 0 0-.157.95Zm10.322-2.383c.171-.355.457-.652.872-.894a2.71 2.71 0 0 1 1.387-.382c.457 0 .858.085 1.186.24.329.157.601.37.83.625.228.255.386.567.486.908.1.354.157.723.157 1.12v4.397h-1.415v-3.929c0-.298-.029-.567-.072-.822a2.099 2.099 0 0 0-.243-.695 1.313 1.313 0 0 0-.486-.483c-.2-.113-.472-.17-.801-.17-.557 0-1.015.213-1.386.638-.358.426-.544.993-.544 1.702v3.76h-1.415V11.038h1.415v5.29h.029v.03Zm11.28.085h-1.901v3.688c0 .426.085.724.243.922.171.185.414.27.772.27.128 0 .271-.015.429-.029.157-.028.286-.07.4-.113l.043 1.149a4.84 4.84 0 0 1-.572.142c-.2.028-.415.042-.643.042-.672 0-1.187-.184-1.544-.553-.358-.369-.529-.922-.529-1.66v-3.844h-1.373v-1.163h1.373v-2.042h1.401v2.042h1.901v1.15Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__a",
    width: 51,
    height: 15,
    x: 59,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.947 17.777c0-.525-.172-.922-.486-1.178-.315-.255-.744-.383-1.287-.383-.4 0-.786.085-1.144.241a2.922 2.922 0 0 0-.9.596l-.744-.893a3.82 3.82 0 0 1 1.301-.78 4.821 4.821 0 0 1 1.644-.284c.515 0 .958.07 1.33.213.386.141.686.34.93.595.242.241.428.54.542.88.115.34.172.709.172 1.092v3.092c0 .241.014.497.028.752.015.255.043.482.086.652h-1.286a4.108 4.108 0 0 1-.115-1.007h-.043c-.257.383-.6.667-.986.88-.386.212-.872.312-1.416.312-.285 0-.571-.029-.872-.114a2.316 2.316 0 0 1-.829-.369 2.181 2.181 0 0 1-.629-.666c-.172-.284-.243-.624-.243-1.036 0-.539.143-.964.443-1.29a2.92 2.92 0 0 1 1.144-.724c.472-.17 1.015-.27 1.601-.312.6-.043 1.187-.07 1.787-.07l-.028-.2Zm-.343 1.22c-.358 0-.715.014-1.087.042-.386.028-.73.1-1.015.17a2.12 2.12 0 0 0-.758.397c-.2.17-.3.426-.3.724 0 .213.043.383.129.525.085.141.2.255.343.34.143.1.3.156.457.184.158.029.343.043.53.043.671 0 1.172-.199 1.529-.596.357-.383.529-.893.529-1.49v-.368h-.357v.028Zm6.39-6.27c0 .255-.1.468-.271.652a.944.944 0 0 1-.672.256.91.91 0 0 1-.658-.256.823.823 0 0 1-.272-.638c0-.255.1-.468.272-.652.172-.185.4-.256.658-.256.257 0 .486.085.672.256a.852.852 0 0 1 .271.638Zm-.228 9.645H68.35V15.28h1.416v7.092Zm4.703 0h-1.501V11.791h3.417c.515 0 1 .042 1.458.156.458.1.872.27 1.215.51.344.227.615.525.815.908.2.383.3.823.3 1.362 0 .78-.243 1.404-.729 1.886-.486.483-1.1.78-1.858.908l2.974 4.866h-1.802l-2.716-4.71H74.44v4.71l.028-.015Zm0-5.957h1.716c.357 0 .672-.028.986-.1.3-.056.572-.155.8-.297.23-.128.401-.312.53-.525.128-.213.2-.482.2-.794 0-.313-.072-.596-.2-.795a1.693 1.693 0 0 0-.53-.525 2.09 2.09 0 0 0-.757-.27c-.3-.056-.6-.084-.915-.084h-1.83v3.39Zm10.008-3.688c0 .255-.1.468-.272.652a.944.944 0 0 1-.672.256.933.933 0 0 1-.657-.256.823.823 0 0 1-.272-.638c0-.255.1-.468.272-.652.171-.185.4-.256.657-.256.258 0 .472.085.672.256a.852.852 0 0 1 .272.638Zm-.229 9.645h-1.415V15.28h1.415v7.092Zm3.703 1.206c.315.355.7.624 1.158.837.458.213.944.312 1.43.312.472 0 .872-.071 1.186-.199.315-.127.587-.312.772-.553.2-.241.33-.51.43-.823.085-.312.128-.666.128-1.035v-.908h-.029c-.257.397-.614.71-1.072.908a3.392 3.392 0 0 1-1.444.312c-.543 0-1.03-.1-1.487-.284a3.266 3.266 0 0 1-1.143-.78 3.581 3.581 0 0 1-.73-1.149 3.961 3.961 0 0 1-.257-1.418c0-.51.086-.993.257-1.433a3.56 3.56 0 0 1 .73-1.177 3.594 3.594 0 0 1 1.129-.794 3.593 3.593 0 0 1 1.473-.298c.514 0 1 .099 1.472.326.458.227.83.553 1.101 1.007h.029v-1.135h1.372v6.724c0 .524-.071 1.007-.2 1.49a3.176 3.176 0 0 1-.672 1.262c-.315.368-.73.666-1.23.865-.5.227-1.129.326-1.858.326a5.512 5.512 0 0 1-1.873-.34 4.807 4.807 0 0 1-1.616-.95l.944-1.093Zm.415-4.837c0 .326.043.653.157.936.1.298.257.568.457.795.2.227.458.411.744.553.3.142.629.213 1 .213.372 0 .701-.057 1.001-.199.3-.128.558-.312.772-.525.215-.227.386-.482.487-.794.114-.312.171-.638.171-.979 0-.34-.057-.666-.171-.95a2.42 2.42 0 0 0-.5-.795 2.29 2.29 0 0 0-.773-.539 2.499 2.499 0 0 0-.986-.198c-.372 0-.7.07-1.001.198-.3.128-.543.313-.744.54-.2.226-.371.482-.457.794a3.01 3.01 0 0 0-.157.95Zm10.322-2.383c.171-.355.457-.652.872-.894a2.71 2.71 0 0 1 1.387-.382c.457 0 .858.085 1.186.24.329.157.601.37.83.625.228.255.386.567.486.908.1.354.157.723.157 1.12v4.397h-1.415v-3.929c0-.298-.029-.567-.072-.822a2.099 2.099 0 0 0-.243-.695 1.313 1.313 0 0 0-.486-.483c-.2-.113-.472-.17-.801-.17-.557 0-1.015.213-1.386.638-.358.426-.544.993-.544 1.702v3.76h-1.415V11.038h1.415v5.29h.029v.03Zm11.28.085h-1.901v3.688c0 .426.085.724.243.922.171.185.414.27.772.27.128 0 .271-.015.429-.029.157-.028.286-.07.4-.113l.043 1.149a4.84 4.84 0 0 1-.572.142c-.2.028-.415.042-.643.042-.672 0-1.187-.184-1.544-.553-.358-.369-.529-.922-.529-1.66v-3.844h-1.373v-1.163h1.373v-2.042h1.401v2.042h1.901v1.15Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__a)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__b",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M59.3 11.039h-.329v14.936h.33V11.04Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__c",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M59.643 11.039h-.328v14.936h.328V11.04Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__d",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M59.958 11.039h-.329v14.936h.329V11.04Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__e",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M60.287 11.039h-.33v14.936h.33V11.04Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__f",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M60.616 11.039h-.33v14.936h.33V11.04Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__g",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M60.959 11.039h-.33v14.936h.33V11.04Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__h",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M61.288 11.039h-.33v14.936h.33V11.04Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__i",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M61.616 11.039h-.328v14.936h.328V11.04Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__j",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M61.93 11.039h-.328v14.936h.329V11.04Z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__k",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M62.26 11.039h-.33v14.936h.33V11.04Z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__l",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M62.603 11.039h-.329v14.936h.329V11.04Z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__m",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M62.932 11.039h-.33v14.936h.33V11.04Z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__n",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.26 11.039h-.328v14.936h.328V11.04Z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__o",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.575 11.039h-.329v14.936h.329V11.04Z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__p",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M63.918 11.039h-.329v14.936h.33V11.04Z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__q",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M64.247 11.039h-.329v14.936h.329V11.04Z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__r",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M64.576 11.039h-.33v14.936h.33V11.04Z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__s",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M64.905 11.039h-.33v14.936h.33V11.04Z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__t",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M65.234 11.039h-.33v14.936h.33V11.04Z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__u",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M65.562 11.039h-.329v14.936h.33V11.04Z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__v",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M65.891 11.039h-.329v14.936h.33V11.04Z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__w",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M66.22 11.039h-.329v14.936h.329V11.04Z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__x",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M66.549 11.039h-.329v14.936h.329V11.04Z"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__y",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M66.877 11.039h-.328v14.936h.328V11.04Z"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__z",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M67.206 11.039h-.328v14.936h.328V11.04Z"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__A",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M67.535 11.039h-.329v14.936h.33V11.04Z"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__B",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M67.864 11.039h-.329v14.936h.33V11.04Z"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__C",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M68.193 11.039h-.329v14.936h.329V11.04Z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__D",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M68.522 11.039h-.33v14.936h.33V11.04Z"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__E",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M68.865 11.039h-.329v14.936h.329V11.04Z"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__F",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M69.18 11.039h-.33v14.936h.33V11.04Z"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__G",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M69.508 11.039h-.329v14.936h.33V11.04Z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__H",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M69.837 11.039h-.329v14.936h.329V11.04Z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__I",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M70.18 11.039h-.329v14.936h.33V11.04Z"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__J",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M70.509 11.039h-.329v14.936h.329V11.04Z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__K",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M70.823 11.039h-.328v14.936h.328V11.04Z"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__L",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.152 11.039h-.329v14.936h.33V11.04Z"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__M",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__M)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.481 11.039h-.329v14.936h.33V11.04Z"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__N",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M71.824 11.039h-.328v14.936h.328V11.04Z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__O",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M72.153 11.039h-.329v14.936h.329V11.04Z"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__P",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M72.482 11.039h-.329v14.936h.329V11.04Z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__Q",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M72.796 11.039h-.328v14.936h.328V11.04Z"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__R",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M73.14 11.039h-.33v14.936h.33V11.04Z"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__S",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M73.468 11.039h-.329v14.936h.33V11.04Z"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__T",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M73.797 11.039h-.329v14.936h.33V11.04Z"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__U",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M74.126 11.039h-.329v14.936h.33V11.04Z"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__V",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M74.44 11.039h-.328v14.936h.329V11.04Z"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__W",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M74.784 11.039h-.33v14.936h.33V11.04Z"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__X",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M75.112 11.039h-.328v14.936h.328V11.04Z"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__Y",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__Y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M75.441 11.039h-.329v14.936h.33V11.04Z"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__Z",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__Z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M75.77 11.039h-.329v14.936h.33V11.04Z"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aa",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M76.099 11.039h-.329v14.936h.329V11.04Z"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ab",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M76.428 11.039h-.329v14.936h.329V11.04Z"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ac",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M76.757 11.039h-.33v14.936h.33V11.04Z"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ad",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M77.085 11.039h-.328v14.936h.328V11.04Z"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ae",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M77.414 11.039h-.329v14.936h.33V11.04Z"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__af",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M77.743 11.039h-.329v14.936h.33V11.04Z"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ag",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ag)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M78.072 11.039h-.329v14.936h.329V11.04Z"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ah",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M78.4 11.039h-.328v14.936h.329V11.04Z"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ai",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ai)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M78.73 11.039h-.33v14.936h.33V11.04Z"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aj",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M79.058 11.039h-.328v14.936h.328V11.04Z"
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ak",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ak)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M79.402 11.039h-.33v14.936h.33V11.04Z"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__al",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__al)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M79.73 11.039h-.328v14.936h.328V11.04Z"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__am",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M80.045 11.039h-.329v14.936h.329V11.04Z"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__an",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M80.374 11.039h-.33v14.936h.33V11.04Z"
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ao",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ao)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M80.703 11.039h-.33v14.936h.33V11.04Z"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ap",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ap)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M81.046 11.039h-.33v14.936h.33V11.04Z"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aq",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M81.375 11.039h-.33v14.936h.33V11.04Z"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ar",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ar)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M81.69 11.039h-.33v14.936h.33V11.04Z"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__as",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__as)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M82.018 11.039h-.329v14.936h.329V11.04Z"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__at",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M82.361 11.039h-.329v14.936h.33V11.04Z"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__au",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__au)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M82.69 11.039h-.329v14.936h.329V11.04Z"
  }))), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__av",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__av)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M83.019 11.039h-.33v14.936h.33V11.04Z"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aw",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M83.347 11.039h-.328v14.936h.328V11.04Z"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ax",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ax)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M83.662 11.039h-.329v14.936h.33V11.04Z"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ay",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ay)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.005 11.039h-.329v14.936h.33V11.04Z"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__az",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.334 11.039h-.329v14.936h.329V11.04Z"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aA",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.663 11.039h-.329v14.936h.329V11.04Z"
  }))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aB",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M84.992 11.039h-.33v14.936h.33V11.04Z"
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aC",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.32 11.039h-.328v14.936h.328V11.04Z"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aD",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.65 11.039h-.33v14.936h.33V11.04Z"
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aE",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M85.978 11.039h-.329v14.936h.33V11.04Z"
  }))), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aF",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M86.307 11.039h-.329v14.936h.329V11.04Z"
  }))), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aG",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M86.636 11.039h-.33v14.936h.33V11.04Z"
  }))), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aH",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M86.965 11.039h-.33v14.936h.33V11.04Z"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aI",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.293 11.039h-.328v14.936h.328V11.04Z"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aJ",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.622 11.039h-.329v14.936h.33V11.04Z"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aK",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M87.951 11.039h-.329v14.936h.33V11.04Z"
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aL",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M88.28 11.039h-.329v14.936h.329V11.04Z"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aM",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M88.623 11.039h-.329v14.936h.329V11.04Z"
  }))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aN",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M88.952 11.039h-.329v14.936h.329V11.04Z"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aO",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M89.266 11.039h-.329v14.936h.33V11.04Z"
  }))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aP",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M89.595 11.039h-.329v14.936h.33V11.04Z"
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aQ",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M89.924 11.039h-.329v14.936h.329V11.04Z"
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aR",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M90.267 11.039h-.329v14.936h.33V11.04Z"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aS",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M90.596 11.039h-.329v14.936h.329V11.04Z"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aT",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M90.91 11.039h-.328v14.936h.329V11.04Z"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aU",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M91.24 11.039h-.33v14.936h.33V11.04Z"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aV",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M91.568 11.039h-.329v14.936h.33V11.04Z"
  }))), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aW",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M91.911 11.039h-.329v14.936h.33V11.04Z"
  }))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aX",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M92.24 11.039h-.329v14.936h.33V11.04Z"
  }))), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aY",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M92.569 11.039h-.329v14.936h.329V11.04Z"
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__aZ",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M92.883 11.039h-.328v14.936h.328V11.04Z"
  }))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__ba",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M93.227 11.039h-.33v14.936h.33V11.04Z"
  }))), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bb",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M93.555 11.039h-.328v14.936h.328V11.04Z"
  }))), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bc",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M93.884 11.039h-.329v14.936h.33V11.04Z"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bd",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M94.213 11.039h-.329v14.936h.33V11.04Z"
  }))), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__be",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M94.528 11.039h-.33v14.936h.33V11.04Z"
  }))), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bf",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M94.87 11.039h-.328v14.936h.329V11.04Z"
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bg",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bg)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M95.2 11.039h-.33v14.936h.33V11.04Z"
  }))), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bh",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M95.528 11.039H95.2v14.936h.328V11.04Z"
  }))), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bi",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bi)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M95.857 11.039h-.329v14.936h.33V11.04Z"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bj",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M96.186 11.039h-.329v14.936h.329V11.04Z"
  }))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bk",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bk)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M96.515 11.039h-.329v14.936h.329V11.04Z"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bl",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M96.844 11.039h-.33v14.936h.33V11.04Z"
  }))), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bm",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bm)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.173 11.039h-.33v14.936h.33V11.04Z"
  }))), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bn",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.501 11.039h-.329v14.936h.33V11.04Z"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bo",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bo)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M97.83 11.039h-.329v14.936h.33V11.04Z"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bp",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M98.159 11.039h-.329v14.936h.329V11.04Z"
  }))), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bq",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M98.488 11.039h-.329v14.936h.329V11.04Z"
  }))), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__br",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__br)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M98.817 11.039h-.33v14.936h.33V11.04Z"
  }))), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bs",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bs)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M99.145 11.039h-.328v14.936h.329V11.04Z"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bt",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M99.489 11.039h-.33v14.936h.33V11.04Z"
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bu",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bu)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M99.817 11.039h-.328v14.936h.328V11.04Z"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bv",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M100.132 11.039h-.329v14.936h.329V11.04Z"
  }))), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bw",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bw)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M100.461 11.039h-.329v14.936h.329V11.04Z"
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bx",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M100.79 11.039h-.329v14.936h.329V11.04Z"
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__by",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__by)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M101.133 11.039h-.329v14.936h.329V11.04Z"
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bz",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M101.462 11.039h-.329v14.936h.329V11.04Z"
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bA",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bA)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M101.776 11.039h-.329v14.936h.329V11.04Z"
  }))), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bB",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M102.105 11.039h-.329v14.936h.329V11.04Z"
  }))), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bC",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M102.448 11.039h-.329v14.936h.329V11.04Z"
  }))), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bD",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M102.777 11.039h-.329v14.936h.329V11.04Z"
  }))), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bE",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bE)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M103.106 11.039h-.329v14.936h.329V11.04Z"
  }))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bF",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M103.435 11.039h-.329v14.936h.329V11.04Z"
  }))), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bG",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bG)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M103.749 11.039h-.329v14.936h.329V11.04Z"
  }))), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bH",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M104.092 11.039h-.329v14.936h.329V11.04Z"
  }))), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bI",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bI)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M104.421 11.039h-.329v14.936h.329V11.04Z"
  }))), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bJ",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M104.75 11.039h-.329v14.936h.329V11.04Z"
  }))), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bK",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bK)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M105.079 11.039h-.329v14.936h.329V11.04Z"
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bL",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M105.407 11.039h-.328v14.936h.328V11.04Z"
  }))), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bM",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bM)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M105.736 11.039h-.329v14.936h.329V11.04Z"
  }))), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bN",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M106.065 11.039h-.329v14.936h.329V11.04Z"
  }))), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bO",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bO)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M106.394 11.039h-.329v14.936h.329V11.04Z"
  }))), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bP",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M106.723 11.039h-.329v14.936h.329V11.04Z"
  }))), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bQ",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bQ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M107.052 11.039h-.329v14.936h.329V11.04Z"
  }))), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bR",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M107.38 11.039h-.328v14.936h.328V11.04Z"
  }))), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bS",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bS)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M107.709 11.039h-.329v14.936h.329V11.04Z"
  }))), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bT",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M108.038 11.039h-.329v14.936h.329V11.04Z"
  }))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bU",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bU)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M108.367 11.039h-.329v14.936h.329V11.04Z"
  }))), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bV",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M108.71 11.039h-.329v14.936h.329V11.04Z"
  }))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bW",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bW)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M109.039 11.039h-.329v14.936h.329V11.04Z"
  }))), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bX",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M109.353 11.039h-.328v14.936h.328V11.04Z"
  }))), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bY",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bY)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M109.682 11.039h-.329v14.936h.329V11.04Z"
  }))), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "LogoIconEvent_svg__bZ",
    width: 53,
    height: 15,
    x: 58,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LogoIconEvent_svg__bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-.329v14.936h.329V11.04Z"
  }))), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M110.011 11.039h-51.04v14.936h51.04V11.04Z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 13,
    x: 59,
    y: 29.961,
    fill: "#FBEFEB",
    rx: 6.5
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M64.84 40.001v-.86h2.04c.393 0 .697-.11.91-.33.22-.227.33-.527.33-.9 0-.38-.107-.677-.32-.89-.213-.22-.52-.33-.92-.33h-2.04v-.64h1.9c.467 0 .877.057 1.23.17.36.113.64.303.84.57.207.26.31.617.31 1.07v.14c0 .427-.087.79-.26 1.09-.173.293-.437.52-.79.68-.353.153-.797.23-1.33.23h-1.9Zm-.78 0v-7.38h.98v7.38h-.98Zm.78-3.49v-.64h1.77c.413 0 .717-.11.91-.33.2-.227.3-.513.3-.86 0-.353-.1-.64-.3-.86-.193-.227-.497-.34-.91-.34h-1.77v-.86h1.6c.8 0 1.397.17 1.79.51.393.333.59.817.59 1.45v.14c0 .447-.1.803-.3 1.07-.2.26-.48.447-.84.56-.353.107-.767.16-1.24.16h-1.6Zm8.108 3.63c-.467 0-.87-.08-1.21-.24-.34-.16-.617-.37-.83-.63a2.81 2.81 0 0 1-.48-.89c-.1-.327-.15-.66-.15-1v-.18c0-.347.05-.683.15-1.01.106-.327.267-.62.48-.88.213-.267.483-.477.81-.63.333-.16.723-.24 1.17-.24.58 0 1.056.127 1.43.38.38.247.66.567.84.96.186.393.28.813.28 1.26v.43h-4.74v-.72h4.04l-.22.39c0-.38-.06-.707-.18-.98-.12-.28-.3-.497-.54-.65-.24-.153-.544-.23-.91-.23-.38 0-.697.087-.95.26a1.61 1.61 0 0 0-.56.71c-.12.3-.18.647-.18 1.04 0 .38.06.723.18 1.03.126.3.32.54.58.72.26.173.59.26.99.26.42 0 .76-.093 1.02-.28.266-.187.426-.403.48-.65h.9c-.073.367-.22.683-.44.95-.22.267-.497.47-.83.61-.334.14-.71.21-1.13.21Zm5.933-.12c-.4 0-.747-.057-1.04-.17a1.322 1.322 0 0 1-.67-.58c-.154-.28-.23-.657-.23-1.13v-5.14h.92v5.26c0 .287.076.51.23.67.16.153.383.23.67.23h.94v.86h-.82Zm-2.86-4.68v-.72h3.68v.72h-3.68Zm8.248 4.62v-1.6h-.16v-1.85c0-.367-.096-.643-.29-.83-.187-.187-.463-.28-.83-.28-.207 0-.42.003-.64.01l-.63.02a9.31 9.31 0 0 0-.52.03v-.84c.147-.013.3-.023.46-.03.167-.013.337-.02.51-.02.174-.007.34-.01.5-.01.547 0 .993.067 1.34.2.347.127.603.337.77.63.167.293.25.69.25 1.19v3.38h-.76Zm-1.75.14c-.4 0-.747-.067-1.04-.2-.287-.14-.51-.34-.67-.6-.153-.26-.23-.573-.23-.94 0-.38.084-.697.25-.95.174-.253.424-.443.75-.57.327-.133.72-.2 1.18-.2h1.45v.72h-1.49c-.386 0-.683.093-.89.28a.927.927 0 0 0-.31.72c0 .293.103.53.31.71.207.18.504.27.89.27.227 0 .444-.04.65-.12.207-.087.377-.227.51-.42.14-.2.217-.473.23-.82l.26.38c-.033.38-.126.7-.28.96a1.448 1.448 0 0 1-.62.58c-.26.133-.576.2-.95.2Z"
  })));
};
export default SvgLogoIconEvent;